import { IColumn } from '@repo/ui';
import { useLegends } from 'presentation/app/hooks/useLegends';

export const makeStudentsIndividualWorkloadReportColumns = (): IColumn[] => {
  const { getLegends } = useLegends();

  return [
    {
      title: getLegends('ESTUDANTE', false),
      dataKey: 'student',
      width: 370,
      cellRenderer: ({ rowData }) => (
        <span className="text-primary fw-semibold fs-6">
          {rowData?.student || '--'}
        </span>
      ),
    },
    { title: getLegends('GRUPO', false), dataKey: 'group', width: 370 },
    { title: 'CH Total', dataKey: 'totalWorkload' },
    { title: 'CH Validada', dataKey: 'validatedWorkload' },
    { title: `CH ${getLegends('GRUPO', false)}`, dataKey: 'groupWorkload' },
    {
      title: 'Última Nota',
      dataKey: 'lastGrade',
      cellRenderer: ({ rowData }) => <span>{rowData?.lastGrade || '--'}</span>,
    },
  ];
};
